// extracted by mini-css-extract-plugin
export default {"imageGallery":"ImageGallery_imageGallery__d5v5R","spiner":"ImageGallery_spiner__CEJ+q"};